import {ChangeDetectionStrategy, Component, input, output} from '@angular/core';
import {MatButtonModule} from '@angular/material/button';
import {MatDividerModule} from '@angular/material/divider';
import {MatIconModule} from '@angular/material/icon';
import {MatTooltipModule} from '@angular/material/tooltip';
import {GenericActionsComponent} from '../../generic-actions/generic-actions.component';
import {GenericMenuItem} from '../../generic-menu/generic-menu-item.model';

/**
 * Standardized dialog header with optional generic actions and close handling.
 */
@Component({
  selector: 'hypecast-dialog-header',
  imports: [MatButtonModule, MatDividerModule, MatIconModule, MatTooltipModule, GenericActionsComponent],
  templateUrl: './dialog-header.component.html',
  styleUrl: './dialog-header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DialogHeaderComponent {
  readonly closeTooltipText = input('Close the dialog');
  readonly dividerIsVisible = input(true);
  readonly items = input<GenericMenuItem[]>([]);
  readonly title = input('');
  readonly emitCloseClick = output<boolean>();
}
